import { render, staticRenderFns } from "./ScreenDebugTopics.vue?vue&type=template&id=3defac6a&scoped=true"
import script from "./ScreenDebugTopics.vue?vue&type=script&lang=js"
export * from "./ScreenDebugTopics.vue?vue&type=script&lang=js"
import style0 from "./ScreenDebugTopics.vue?vue&type=style&index=0&id=3defac6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3defac6a",
  null
  
)

export default component.exports